import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EllipsisVerticalIcon, PlusIcon } from '@heroicons/react/24/outline';
import { toast } from 'react-toastify';
import TableCustom from '../../../../../components/v2/TableCustom';
import EmptyCreatePage from '../../../../../components/v2/EmptyCreatePage';
import { Badge } from '../../../../../empreenderUI/ui/Badge/Badge';
import { Button } from '../../../../../empreenderUI/ui/Button';
import { Checkbox } from '../../../../../empreenderUI/ui/Checkbox';
import { sizeFiles } from '../../../../../utils/convert';
import { translations } from '../../../../../utils/language';
import ModalMenuMedia from '../../modal-menu-media';
import ModalUploadFiles from '../../modal-upload-files';
import ModalConectarAnexo from '../../../../products/components/modal-conectar-anexo';
import ModalUploadAnexoNew from '../../../../products/components/modal-upload-anexo-new';
import ModalMenuCad from '../../modal-menu-cad';
import ModalCadLinkNew from '../../../../products/components/modal-cad-link-new';
import ModalFeedDelete from '../modal-feed-delete';
import ModalFeedCompleted from '../../../../../components/tailwind/modal-feed-completed';
import ModalMenuItem from '../../modal-menu-item';
import ModalRenomearMidia from '../../modal-renomear-midia';
import { clearVariantsCache } from '../../../../products/components/products-table/VariantsExpandPanel';
import { Trash2, X } from 'lucide-react';

function getTypeBadgeColor(type) {
  switch (type?.toLowerCase()) {
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'bmp':
    case 'psd':
    case 'svg':
    case 'webp':
      return 'blue';
    case 'pdf':
      return 'red';
    case 'url':
      return 'indigo';
    case 'mp4':
    case 'avi':
    case 'mkv':
    case 'mov':
    case 'webm':
      return 'purple';
    case 'zip':
    case 'rar':
    case '7z':
      return 'yellow';
    case 'doc':
    case 'docx':
    case 'txt':
      return 'green';
    case 'xls':
    case 'xlsx':
    case 'csv':
      return 'green';
    case 'ppt':
    case 'pptx':
      return 'pink';
    default:
      return 'gray';
  }
}

function TypeBadge({ type }) {
  if (!type) return <span className='text-sm text-gray-400'>—</span>;
  const label = String(type).toUpperCase();
  return (
    <Badge variant='primary' color={getTypeBadgeColor(type)} className='uppercase tracking-wide'>
      {label}
    </Badge>
  );
}

export default function TableMedias(props) {
  const [selectedMedias, setSelectedMedias] = useState([]);
  const dispatch = useDispatch();

  const [visibleModalMenu, setvisibleModalMenu] = useState(false);
  const [visibleModalUploadFiles, setVisibleModalUploadFiles] = useState(false);
  const [visibleModalConectar, setVisibleModalConectar] = useState(false);
  const [visibleModalMenuCad, setVisibleModalMenuCad] = useState(false);
  const [visibleModalCadLink, setVisibleModalCadLink] = useState(false);
  const [visibleModalFeedDelete, setVisibleModalFeedDelete] = useState(false);
  const [visibleModalCompletedFeed, setVisibleModalCompletedFeed] = useState(false);
  const [visibeModalAnexoNew, setVisibeModalAnexoNew] = useState(false);

  const [dataMedias, setDataMedias] = useState([]);
  const [dataModalDeleteCompleted, setDataModalDeleteCompleted] = useState([]);
  const [mediaLoadingId, setMediaLoadingId] = useState(null);

  const [menuItem, setMenuItem] = useState(null);
  const [visibleModalMenuItem, setVisibleModalMenuItem] = useState(false);
  const [renameItem, setRenameItem] = useState(null);
  const [visibleModalRenomear, setVisibleModalRenomear] = useState(false);

  const medias = useSelector((state) => state.reducerMedias);
  const language = useSelector((state) => state.reducerLanguage);
  const lang = language?.data || 'pt';
  const statusDeleteMedias = useSelector((state) => state.reducerDeleteMedias);
  const statusUpdateMedias = useSelector((state) => state.reducerUpdateMedias);

  useEffect(() => {
    // Soft refresh: não limpa a lista só porque entrou em loading
    if (medias.loading) return;
    if (Array.isArray(medias?.data?.data)) setDataMedias(medias.data.data);
    else if (medias?.data?.data == undefined) setDataMedias([]);
  }, [medias]);

  const allSelected = dataMedias.length > 0 && selectedMedias.length === dataMedias.length;
  const someSelected = selectedMedias.length > 0 && selectedMedias.length < dataMedias.length;

  const handleClick = () => {
    setSelectedMedias([]);
  };

  const toggleAll = (value) => {
    setSelectedMedias(value === true ? dataMedias : []);
  };

  const isSelected = (item) => selectedMedias.some((m) => m.id === item.id);

  const toggleSelect = (item, value) => {
    setSelectedMedias((prev) => (value === true ? [...prev, item] : prev.filter((p) => p.id !== item.id)));
  };

  const requestItems = async () => {
    for (const item of selectedMedias) {
      try {
        setMediaLoadingId(item.id);
        const token = JSON.parse(localStorage.getItem('depoimentos@login'))?.access_token.token;
        const url = `${process.env.REACT_APP_API_URL}/delete_media/${item.id}`;
        const headers = new Headers({ Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' });
        await fetch(url, { method: 'DELETE', headers });
        setDataModalDeleteCompleted((prevData) => [...prevData, item.id]);
        setMediaLoadingId(null);
      } catch (error) {
        console.error(`Erro na requisição do item ${item.media_name}:`, error.message);
      }
    }

    clearVariantsCache();
    setVisibleModalFeedDelete(false);
    setVisibleModalCompletedFeed(true);
  };

  const closeModal = () => {
    handleClick();
    setTimeout(() => {
      setVisibleModalCompletedFeed(false);
      props.goSearch?.();
      setDataModalDeleteCompleted([]);
      setSelectedMedias([]);
    }, 10);
  };

  const renameMedia = (name, url) => {
    if (!renameItem) return;
    if (renameItem.type === 'url') {
      dispatch({ type: 'SAGA_UPDATE_NEW_MEDIA', payload: { id: renameItem.id, media: url, media_name: name } });
    } else {
      dispatch({ type: 'SAGA_UPDATE_NEW_MEDIA', payload: { id: renameItem.id, media_name: name } });
    }
    setVisibleModalRenomear(false);
    props.goSearch?.();
  };

  useEffect(() => {
    if (!(statusDeleteMedias.loading == null && statusDeleteMedias.error == null && statusDeleteMedias.data.length == 0)) {
      const id = 'statusDeleteMedias';
      if (statusDeleteMedias.loading) {
        toast.loading(translations['Aguarde...'][lang], { toastId: id });
      } else if (statusDeleteMedias.error) {
        toast.update(id, { render: translations['medias-erro-excluir'][lang], type: 'error', isLoading: false, hideProgressBar: false, autoClose: 3000, closeOnClick: true });
      } else {
        toast.update(id, { render: translations['medias-excluido-sucesso'][lang], type: 'success', isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true });
      }
    }
  }, [statusDeleteMedias]);

  useEffect(() => {
    if (!(statusUpdateMedias.loading == null && statusUpdateMedias.error == null && statusUpdateMedias.data.length == 0)) {
      const id = 'statusUpdateMedias';
      if (statusUpdateMedias.loading) {
        toast.loading(translations['Aguarde...'][lang], { toastId: id });
      } else if (statusUpdateMedias.error) {
        toast.update(id, { render: translations['medias-erro-atualizar'][lang], type: 'error', isLoading: false, hideProgressBar: false, autoClose: 3000, closeOnClick: true });
      } else {
        toast.update(id, { render: translations['medias-atualizado-sucesso'][lang], type: 'success', isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true });
      }
    }
  }, [statusUpdateMedias]);

  const columns = useMemo(() => {
    const cols = [
      {
        label: (
          <Checkbox
            checked={allSelected ? true : someSelected ? 'indeterminate' : false}
            onCheckedChange={toggleAll}
            aria-label={translations['common-select-all-aria'][lang]}
          />
        ),
        className: 'w-10',
      },
      { label: translations['Data'][lang], className: 'w-28' },
      { label: translations['Nome'][lang], className: 'w-auto' },
      { label: translations['medias-table-tipo'][lang], className: 'w-24' },
      { label: translations['medias-table-tamanho'][lang], className: 'w-28' },
    ];

    if (!props.productId) {
      cols.push({ label: translations['Produtos'][lang], className: 'w-24' });
    }

    cols.push({ label: '', className: 'w-12' });
    return cols;
  }, [lang, props.productId, allSelected, someSelected, dataMedias]);

  const displayData = props.productId
    ? [
        {
          id: 'demo-1',
          created_at: '2024-01-01',
          quantity_linked_products: '2',
          type: 'Tipo',
          size: '1gb',
          media_name: 'Teste',
        },
        {
          id: 'demo-2',
          created_at: '2024-01-01',
          quantity_linked_products: '2',
          type: 'Tipo',
          size: '1gb',
          media_name: 'Teste',
        },
      ]
    : dataMedias;

  const rows = useMemo(
    () =>
      displayData.map((item) => {
        const cells = [
          <Checkbox
            key='check'
            checked={isSelected(item)}
            onCheckedChange={(value) => toggleSelect(item, value)}
            aria-label={`${translations['products-select-aria'][lang]} ${item?.media_name || translations['products-file-singular'][lang].toLowerCase()}`}
          />,
          <span key='date' className='text-sm text-gray-900 whitespace-nowrap'>
            {item.created_at ? new Date(item.created_at).toLocaleDateString() : '—'}
          </span>,
          <div key='name' className='min-w-0 flex-1 overflow-hidden'>
            <p className='text-sm font-medium text-gray-900 leading-snug line-clamp-2 break-words max-w-[500px]' title={item?.media_name || translations['products-link-singular'][lang]}>
              {item?.media_name == null ? translations['products-link-singular'][lang] : item.media_name}
            </p>
          </div>,
          <TypeBadge key='type' type={item?.type} />,
          <span key='size' className='text-sm text-gray-600'>
            {item.size != null ? sizeFiles(parseInt(item.size, 10)) : null}
          </span>,
        ];

        if (!props.productId) {
          cells.push(
            <span key='products' className='text-sm text-gray-600'>
              {item.quantity_linked_products ?? 0}
            </span>,
          );
        }

        cells.push(
          <Button
            key='menu'
            type='button'
            variant='secondary'
            size='icon'
            className='size-8'
            onClick={() => {
              setMenuItem(item);
              setVisibleModalMenuItem(true);
            }}
          >
            <EllipsisVerticalIcon className='size-5' />
          </Button>,
        );

        return cells;
      }),
    [displayData, selectedMedias, props.productId, lang],
  );

  const pagination = medias?.data?.meta;

  return (
    <>
      <ModalMenuMedia
        visible={visibleModalMenu}
        setVisibleModal={setvisibleModalMenu}
        setVisibleModalUploadFiles={setVisibleModalUploadFiles}
        setVisibleModalConectar={setVisibleModalConectar}
      />
      <ModalUploadFiles getIconFile={props.getIconFile} visible={visibleModalUploadFiles} setVisible={setVisibleModalUploadFiles} goSearch={props.goSearch} />
      <ModalConectarAnexo getIconFile={props.getIconFile} item={props.item} visible={visibleModalConectar} setVisible={setVisibleModalConectar} />
      <ModalUploadAnexoNew setVisible={setVisibeModalAnexoNew} visible={visibeModalAnexoNew} goSearch={props.goSearch} />
      <ModalMenuCad
        visibleModalMenuCad={visibleModalMenuCad}
        setVisibleModalMenuCad={setVisibleModalMenuCad}
        setVisibeModalAnexoNew={setVisibeModalAnexoNew}
        setVisibleModalCadLink={setVisibleModalCadLink}
      />
      <ModalCadLinkNew setVisible={setVisibleModalCadLink} visible={visibleModalCadLink} goSearch={props.goSearch} />
      <ModalFeedDelete
        setVisible={setVisibleModalFeedDelete}
        visible={visibleModalFeedDelete}
        selectedMedias={selectedMedias}
        dataModalDeleteCompleted={dataModalDeleteCompleted}
        setDataModalDeleteCompleted={setDataModalDeleteCompleted}
        mediaLoadingId={mediaLoadingId}
        goSearch={props.goSearch}
        handleClick={handleClick}
      />
      <ModalFeedCompleted
        setVisible={setVisibleModalCompletedFeed}
        visible={visibleModalCompletedFeed}
        title={translations['medias-exclusao-completa'][lang]}
        desc={translations['medias-exclusao-completa-desc'][lang]}
        close={closeModal}
      />

      {menuItem && (
        <ModalMenuItem
          item={menuItem}
          visible={visibleModalMenuItem}
          setVisibleModal={setVisibleModalMenuItem}
          setVisibleModalRenomear={(open) => {
            if (open) {
              setRenameItem(menuItem);
              setVisibleModalRenomear(true);
            }
            setVisibleModalMenuItem(false);
          }}
        />
      )}

      {renameItem && (
        <ModalRenomearMidia
          key={renameItem.id}
          renameMedia={renameMedia}
          item={renameItem}
          visible={visibleModalRenomear}
          setVisible={setVisibleModalRenomear}
        />
      )}

      {!medias.loading && displayData.length === 0 ? (
        <EmptyCreatePage
          showAlert={false}
          showButtons={!props.productId}
          title={translations['page-medias-title'][lang]}
          description={translations['medias-nao-midias'][lang]}
          createButtonText={translations['medias-cadastrar'][lang]}
          onCreateClick={!props.productId ? () => setVisibleModalMenuCad(true) : undefined}
          benefits={[
            translations['medias-empty-benefit-1'][lang],
            translations['medias-empty-benefit-2'][lang],
            translations['medias-empty-benefit-3'][lang],
            translations['medias-empty-benefit-4'][lang],
            translations['medias-empty-benefit-5'][lang],
          ]}
        />
      ) : (
        <div className='px-4 sm:px-6 lg:px-8 w-full max-w-full min-w-0 box-border'>
          {props.navbar && props.navbar}

          <div className='flex items-start justify-between gap-4 mb-6 min-w-0'>
            <div className='min-w-0'>
              <h1 className='text-2xl font-semibold tracking-tight text-gray-900'>{translations['page-medias-title'][lang]}</h1>
              <p className='mt-2 text-sm text-gray-500'>{translations['page-medias-description'][lang]}</p>
            </div>
          </div>

          <TableCustom
            className='w-full max-w-full min-w-0'
            title={null}
            setSearch={props.setSearch}
            searchValue={props.search}
            searchPlaceholder={translations['medias-pesquisar']?.[lang] || translations['products-pesquisar-nome']?.[lang] || 'Pesquisar…'}
            onSearchSubmit={() => {
              props.setPage?.(1);
              props.goSearch?.();
            }}
            columns={columns}
            data={displayData}
            rows={rows}
            pagination={pagination}
            isLoading={!!medias.loading && dataMedias.length === 0}
            getData={(p) => props.setPage?.(p)}
            hideSearch={!props.setSearch}
            getRowKey={(item) => item?.id}
            actionTable={
              !props.productId
                ? [
                    {
                      label: (
                        <>
                          <PlusIcon className='size-4' />
                          {translations['medias-cadastrar'][lang]}
                        </>
                      ),
                      onClick: () => setVisibleModalMenuCad(true),
                      variant: 'default',
                      visible: true,
                    },
                  ]
                : []
            }
          />
        </div>
      )}

      {selectedMedias.length > 0 && (
        <div className='fixed bottom-4 left-1/2 z-50 w-[min(920px,calc(100%-2rem))] -translate-x-1/2 rounded-xl border border-slate-700/80 bg-slate-900/95 px-4 sm:px-5 py-3 shadow-[0_12px_40px_rgba(0,0,0,0.45)] backdrop-blur-sm'>
          <div className='flex flex-wrap items-center justify-between gap-3'>
            <div className='min-w-0'>
              <p className='text-sm font-semibold text-white'>
                {selectedMedias.length} {selectedMedias.length === 1 ? translations['medias-selected-one'][lang] : translations['medias-selected-many'][lang]}
              </p>
              <p className='text-xs text-slate-400'>{translations['medias-deletar-selecionados'][lang]}</p>
            </div>
            <div className='flex items-center gap-2 shrink-0'>
              <Button
                variant='outline'
                className='border-slate-600 bg-transparent text-red-400 hover:bg-red-950/50 hover:text-red-300 hover:border-red-800'
                onClick={() => {
                  requestItems();
                  setVisibleModalFeedDelete(true);
                }}
              >
                <Trash2 className='size-4' />
                {translations['medias-excluir'][lang]}
              </Button>
              <Button
                type='button'
                variant='secondary'
                size='icon'
                className='size-8 shrink-0 border-0 bg-slate-700 text-slate-200 hover:bg-slate-600 hover:text-white'
                aria-label={translations['common-clear-selection'][lang]}
                onClick={() => setSelectedMedias([])}
              >
                <X className='size-4' />
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
